/**
 * Shared share calculation constants and helpers.
 *
 * 1 Share = 10,000 FRW (configurable via backend settings).
 * This file is the single source of truth for the frontend.
 */

/** Value of one share in FRW. Must match the backend configured share value. */
export const SHARE_VALUE = 10_000;

/**
 * Calculate the number of shares from a savings amount.
 * Returns a decimal rounded to 2 places (e.g., 1.33 shares).
 * Falls back to 0 if the input is invalid or non-positive.
 */
export function calculateShares(totalSavings: number | null | undefined): number {
  const amount = Number(totalSavings) || 0;
  if (amount <= 0) return 0;
  return Math.round((amount / SHARE_VALUE) * 100) / 100;
}

/**
 * Defensive: returns totalShares if present, otherwise derives from totalSavings.
 * Use this wherever the UI needs to display shares.
 */
export function getShares(
  totalShares: number | null | undefined,
  totalSavings: number | null | undefined
): number {
  if (totalShares != null && totalShares > 0) return Number(totalShares);
  return calculateShares(totalSavings);
}
